/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    IWizardAdditionalAccountsSetStepValidPayload,
    TWizardAdditionalAccountsHandleNextAction,
    TWizardAdditionalAccountsSetParamsAction,
    TWizardAdditionalAccountsSetParamsPayload,
    TWizardAdditionalAccountsSetStepValidAction,
    TWizardAdditionalAccountsStartValidateAction,
} from './types/wizardAdditionalAccountsActionTypes';
import {
    WIZARD_ADDITIONAL_ACCOUNTS_HANDLE_NEXT,
    WIZARD_ADDITIONAL_ACCOUNTS_SET_PARAMS,
    WIZARD_ADDITIONAL_ACCOUNTS_SET_STEP_VALID,
    WIZARD_ADDITIONAL_ACCOUNTS_START_VALIDATE,
} from './wizardAdditionalAccountsConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardAdditionalAccountsHandleNextAction = (): TWizardAdditionalAccountsHandleNextAction =>
    createAction(WIZARD_ADDITIONAL_ACCOUNTS_HANDLE_NEXT);

export const wizardAdditionalAccountsSetParamsAction = (payload: TWizardAdditionalAccountsSetParamsPayload):
    TWizardAdditionalAccountsSetParamsAction =>
    createAction(WIZARD_ADDITIONAL_ACCOUNTS_SET_PARAMS, payload);

export const wizardAdditionalAccountsStartValidateAction = ():
    TWizardAdditionalAccountsStartValidateAction => createAction(WIZARD_ADDITIONAL_ACCOUNTS_START_VALIDATE);

export const wizardAdditionalAccountsSetStepValidAction = (payload: IWizardAdditionalAccountsSetStepValidPayload):
    TWizardAdditionalAccountsSetStepValidAction => createAction(WIZARD_ADDITIONAL_ACCOUNTS_SET_STEP_VALID, payload);
